import React from "react";

class ProfilePic extends React.Component {
  state = {
    email:
      this.props.user && this.props.user.email ? this.props.user.email : "a",
  };
  componentDidUpdate() {
    if (
      this.props.user &&
      this.props.user.email &&
      this.props.user.email !== this.state.email
    ) {
      this.setState({ email: this.props.user.email });
    }
  }
  render() {
    return (
      <div
        className={this.props.lg ? "profile-pic-lg" : "profile-pic"}
        style={{
          backgroundImage: `url('https://dlttx48mxf9m3.cloudfront.net/users/${this.state.email
            .substring(0, 1)
            .toLowerCase()}.png')`,
        }}
      ></div>
    );
  }
}
export default ProfilePic;
